/* Ban-78 — search with Shopify's own search (replaces the Searchanise box).
   Phone: the magnifier in the header opens a full-screen search. Computer: suggestions open under the header box.
   Also used by the box on the search page.
   - Nothing typed: recent searches (kept on this device only), "Popular right now" (Customize › Header), and on a
     phone "Shop by recipient" / "Shop by gift type" (sections/ez-search-panel.liquid, loaded once).
   - Typing (2+ letters): search words, collections with their number of gifts, 4 products, "See all results"
     (sections/ez-search-suggest.liquid through Shopify's /search/suggest).
   - Enter / See all: /search?q=…&type=product — the results page with the filters. */
(function () {
  "use strict";
  var KEY = "search-recent", MAX = 5;
  var dialog, popular = [], xHtml = null, xLoading = null, cache = {};

  function q(s, el) { return (el || document).querySelector(s); }
  function qa(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }
  /* Ban-108: a search word that names a gift type ("wall art", "mug", "hoodie") opens the results with that Gift type
     filter already on. Shopify's search also returns products that share only one word or a related meaning: "wall art"
     gave 901 results with 440 that were not wall art, and "mug" sorted by price showed 12 ornaments first. The filter
     chip on the results page takes it off again. Only when the words name exactly one type; values = the
     custom.gg_product_type metafield the Gift type filter uses. */
  var FKEY = "filter.p.m.custom.gg_product_type";
  var TYPES = [
    ["wall_art", "wall art|wall decor|poster|posters|canvas|canvas print|canvas prints|painting|paintings"],
    ["ornament", "ornament|ornaments"],
    ["tumbler", "tumbler|tumblers|mug|mugs|coffee mug|coffee mugs"],
    ["apparel", "t shirt|t shirts|tshirt|tshirts|tee|tees|shirt|shirts|sweatshirt|sweatshirts|hoodie|hoodies|sweater|sweaters"],
    ["bedding", "blanket|blankets|pillow|pillows"],
    ["hat_cap", "hat|hats|cap|caps"],
    ["doormat", "doormat|doormats|door mat|door mats"],
    ["keychain", "keychain|keychains|key chain|key chains"],
    ["towel", "towel|towels"],
    ["plaque", "plaque|plaques"],
    ["lighting", "lamp|lamps|night light|night lights"],
    ["bag", "bag|bags|tote|totes"]
  ];
  function giftType(t) {
    var s = " " + String(t || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim() + " ", hit = null;
    for (var i = 0; i < TYPES.length; i++) {
      var words = TYPES[i][1].split("|");
      for (var j = 0; j < words.length; j++) {
        if (s.indexOf(" " + words[j] + " ") > -1) {
          if (hit && hit !== TYPES[i][0]) return null;   // "canvas bag": two types named, no filter
          hit = TYPES[i][0];
          break;
        }
      }
    }
    return hit;
  }
  function withType(url, t) {
    var g = giftType(t);
    return g && url.indexOf(FKEY) < 0 ? url + "&" + encodeURIComponent(FKEY) + "=" + g : url;
  }
  function link(t) { return withType("/search?q=" + encodeURIComponent(t) + "&type=product&options%5Bprefix%5D=last", t); }

  /* ---------- recent searches (same key the old search box used, so earlier searches carry over) ---------- */
  function recent() {
    try { var a = JSON.parse(localStorage.getItem(KEY) || "[]"); return Array.isArray(a) ? a.filter(function (v) { return v && String(v).trim(); }) : []; }
    catch (e) { return []; }
  }
  function remember(t) {
    t = String(t || "").trim();
    if (!t || t.length > 60) return;
    var a = recent().filter(function (v) { return String(v).toLowerCase() !== t.toLowerCase(); });
    a.unshift(t);
    try { localStorage.setItem(KEY, JSON.stringify(a.slice(0, MAX))); } catch (e) {}
  }
  function forget() { try { localStorage.removeItem(KEY); } catch (e) {} }

  /* ---------- what shows before anything is typed ---------- */
  var ICON_CLOCK = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="8"/><path d="M12 8v4l3 2"/></svg>';
  var ICON_UP = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 16l5-5 4 4 7-7"/><path d="M15 8h5v5"/></svg>';
  /* Ban-80: phone and computer show the same things (the computer drop-down used to show only "Popular"):
     left column recent + popular, right column recipients + gift types (side by side on a computer). */
  function zeroHtml() {
    var h = "", r = recent();
    if (r.length) {
      h += '<section class="ezs-sec"><div class="ezs-sec__row"><h2 class="ezs-sec__h">Recent searches</h2><span class="ezs-link" role="button" tabindex="0" data-ezs-forget>Clear</span></div><ul class="ezs-chips" role="list">';
      r.forEach(function (t) { h += '<li><a class="ezs-chip ezs-chip--soft" href="' + link(t) + '" data-ezs-term="' + esc(t) + '">' + ICON_CLOCK + esc(t) + "</a></li>"; });
      h += "</ul></section>";
    }
    if (popular.length) {
      h += '<section class="ezs-sec"><h2 class="ezs-sec__h">Popular right now</h2><ul class="ezs-rows" role="list">';
      popular.forEach(function (t) { h += '<li><a class="ezs-row ezs-row--pop" href="' + link(t) + '" data-ezs-term="' + esc(t) + '">' + ICON_UP + "<span>" + esc(t) + "</span></a></li>"; });
      h += "</ul></section>";
    }
    return '<div class="ezs-zero"><div class="ezs-zero__a">' + h + '</div><div class="ezs-xslot" data-ezs-x>' + (xHtml || "") + "</div></div>";
  }
  function explore() {
    if (xHtml !== null || xLoading) return xLoading;
    xLoading = fetch("/?section_id=ez-search-panel", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : ""; })
      .then(function (html) {
        var d = html && new DOMParser().parseFromString(html, "text/html").querySelector(".ezs-xwrap");
        xHtml = d ? d.innerHTML : "";
        qa("[data-ezs-x]").forEach(function (s) { if (!s.innerHTML) s.innerHTML = xHtml; });
      })
      .catch(function () { xHtml = ""; });
    return xLoading;
  }

  /* ---------- one search box ---------- */
  function Box(form, panel, full) {
    var input = q("[data-ezs-input]", form), clear = q("[data-ezs-clear]", form), timer, ctrl, last = null, quiet = false;
    if (!input) return;
    if (!panel) {
      panel = document.createElement("div");
      panel.className = "ezs-drop";
      panel.hidden = true;
      form.appendChild(panel);
    }
    panel.setAttribute("data-ezs-panel", "");
    var floating = !full;

    function show(html) {
      panel.innerHTML = html;
      if (floating) panel.hidden = !html;
      input.setAttribute("aria-expanded", html ? "true" : "false");
    }
    function zero() { last = ""; show(zeroHtml()); explore(); }
    function set(v) { input.value = v || ""; last = null; update(); if (!input.value) zero(); }
    function suggest(t) {
      if (cache[t] !== undefined) { show(cache[t]); return; }
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = "/search/suggest?q=" + encodeURIComponent(t) +
        "&resources%5Btype%5D=query,collection,product&resources%5Blimit%5D=4&resources%5Blimit_scope%5D=each&section_id=ez-search-suggest";
      fetch(url, { credentials: "same-origin", signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (html) {
          var d = html && new DOMParser().parseFromString(html, "text/html").querySelector(".ezs-sug");
          cache[t] = d ? d.outerHTML : "";
          if (input.value.trim() === t) show(cache[t]);
        })
        .catch(function () {});
    }
    function update() {
      var t = input.value.trim();
      if (clear) clear.hidden = !input.value;
      if (t === last) return;
      if (t.length < 2) { if (last !== "") zero(); return; }
      last = t;
      clearTimeout(timer);
      timer = setTimeout(function () { suggest(t); }, 160);
    }

    input.setAttribute("role", "combobox");
    input.setAttribute("aria-autocomplete", "list");
    input.setAttribute("aria-expanded", "false");
    input.addEventListener("input", update);
    input.addEventListener("focus", function () { if (input.readOnly || quiet) { quiet = false; return; } if (input.value.trim().length < 2) zero(); else { last = null; update(); } if (floating && panel.innerHTML) panel.hidden = false; });
    input.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") {
        var l = qa("a[href]", panel)[0];
        if (l) { e.preventDefault(); l.focus(); }
      } else if (e.key === "Escape" && floating) {
        /* Ban-107: keep the words (a search box clears itself on Esc, and that reopened the list) and just close */
        e.preventDefault(); panel.hidden = true; input.setAttribute("aria-expanded", "false");
      }
    });
    panel.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && floating) { panel.hidden = true; input.setAttribute("aria-expanded", "false"); quiet = true; input.focus(); return; }
      if (e.key !== "ArrowDown" && e.key !== "ArrowUp") return;
      var ls = qa("a[href]", panel), i = ls.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      if (e.key === "ArrowDown") { if (ls[i + 1]) ls[i + 1].focus(); }
      else if (i === 0) input.focus(); else ls[i - 1].focus();
    });
    form.addEventListener("submit", function (e) {
      var t = input.value.trim();
      if (!t) { e.preventDefault(); input.focus(); return; }
      remember(t);
      var g = giftType(t), h = form.querySelector('input[name="' + FKEY + '"]');   // Ban-108
      if (g && !h) { h = document.createElement("input"); h.type = "hidden"; h.name = FKEY; form.appendChild(h); }
      if (h) { if (g) h.value = g; else h.parentNode.removeChild(h); }
    });
    if (floating) {
      document.addEventListener("click", function (e) { if (!form.contains(e.target)) { panel.hidden = true; input.setAttribute("aria-expanded", "false"); } });
      form.addEventListener("focusout", function (e) { if (e.relatedTarget && !form.contains(e.relatedTarget)) panel.hidden = true; });
    }
    form.__ezs = { input: input, zero: zero, update: update, set: set };
    /* Ban-80: on a phone the box on the search page opens the full-screen search (with the words already in), instead
       of a drop-down that was hard to get out of. readOnly keeps the keyboard down until the full screen is open. */
    if (floating && !form.classList.contains("ezs-dform") && dialog && window.matchMedia("(max-width: 989px)").matches) {
      input.readOnly = true;
      input.addEventListener("click", function (e) { e.preventDefault(); openDialog(input, input.value); });
      input.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); openDialog(input, input.value); } });
    }
  }

  /* ---------- phone: full-screen search ---------- */
  var opener = null;
  function onKey(e) {
    if (e.key === "Escape") { e.preventDefault(); closeDialog(); return; }
    if (e.key !== "Tab") return;
    var f = qa('a[href], input:not([type="hidden"]), [tabindex="0"]', dialog).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
  function openDialog(from, words) {
    if (!dialog) return;
    opener = from || null;
    dialog.hidden = false;
    var box = q("[data-ezs-form]", dialog).__ezs;
    if (box) { box.input.focus(); box.set(words || ""); } /* focus inside the tap, so the phone keyboard comes up */
    document.body.classList.add("overflow-hidden", "ezs-open-body");
    requestAnimationFrame(function () { dialog.classList.add("is-open"); });
    document.addEventListener("keydown", onKey);
  }
  function closeDialog() {
    if (!dialog || dialog.hidden) return;
    dialog.classList.remove("is-open");
    dialog.hidden = true;
    document.body.classList.remove("overflow-hidden", "ezs-open-body");
    document.removeEventListener("keydown", onKey);
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  function init() {
    dialog = q("[data-ezs-dialog]");
    if (dialog) {
      try { popular = JSON.parse(dialog.getAttribute("data-popular") || "[]").filter(Boolean).slice(0, 6); } catch (e) { popular = []; }
      document.body.appendChild(dialog);
      /* Ban-132 (owner 22/10): on an iPhone a swipe on the full-screen search moved the page underneath (overflow:hidden
         on <body> is ignored there), so the search box slid with it and the caret lagged behind. (1) a swipe that the
         results list cannot use is stopped; (2) once the customer scrolls the results, the keyboard goes down (as in
         the Amazon / Etsy apps) — typing again is one tap on the box. */
      dialog.addEventListener("touchmove", function (e) {
        var t = e.target && e.target.closest ? e.target : null;
        if (!t || t.closest("input, textarea")) return;
        var sc = t.closest(".ezs__body");
        if (!sc || sc.scrollHeight <= sc.clientHeight + 1) e.preventDefault();
      }, { passive: false });
      var list = q(".ezs__body", dialog), y0 = 0;
      if (list) {
        list.addEventListener("touchstart", function () { y0 = list.scrollTop; }, { passive: true });
        list.addEventListener("scroll", function () {
          var a = document.activeElement;
          if (a && a.tagName === "INPUT" && dialog.contains(a) && Math.abs(list.scrollTop - y0) > 12) a.blur();
        }, { passive: true });
      }
    }
    qa("[data-ezs-form]").forEach(function (f) {
      var inDialog = dialog && dialog.contains(f);
      Box(f, inDialog ? q("[data-ezs-panel]", dialog) : q("[data-ezs-panel]", f), !!inDialog);
    });

    /* clicks: open/close, Clear, recent-search Clear, remember the word of a suggestion that was tapped */
    window.addEventListener("click", function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var o = t.closest("[data-ezs-open]");
      if (o && dialog) { e.preventDefault(); openDialog(o); return; }
      if (t.closest("[data-ezs-close]")) { e.preventDefault(); closeDialog(); return; }
      var c = t.closest("[data-ezs-clear]");
      if (c) {
        e.preventDefault();
        var f = c.closest("[data-ezs-form]"), b = f && f.__ezs;
        if (b) { b.input.value = ""; b.update(); b.input.focus(); }
        return;
      }
      var fg = t.closest("[data-ezs-forget]");
      if (fg) {
        e.preventDefault();
        forget();
        var p = fg.closest("[data-ezs-panel]");
        var f2 = p && (p.closest("[data-ezs-form]") || (dialog && dialog.contains(p) ? q("[data-ezs-form]", dialog) : null));
        if (f2 && f2.__ezs) { f2.__ezs.zero(); f2.__ezs.input.focus(); }
        return;
      }
      var term = t.closest("[data-ezs-term]");
      if (term) {
        var w = term.getAttribute("data-ezs-term");
        remember(w);
        /* Ban-108: suggestion rows and "See all results" are drawn by Shopify (ez-search-suggest.liquid): add the Gift
           type here, before the browser follows the link */
        if (term.tagName === "A" && /\/search\?/.test(term.getAttribute("href") || "")) term.setAttribute("href", withType(term.getAttribute("href"), w));
      }
    }, true);
    window.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var t = e.target && e.target.closest && e.target.closest('[role="button"][data-ezs-close],[role="button"][data-ezs-clear],[role="button"][data-ezs-forget]');
      if (t) { e.preventDefault(); t.click(); }
    }, true);
    /* start loading the recipient pictures as the finger touches the magnifier */
    window.addEventListener("pointerdown", function (e) { if (e.target && e.target.closest && e.target.closest("[data-ezs-open]")) explore(); }, { capture: true, passive: true });
    /* a search that reached the results page counts as a recent search */
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?search\/?$/i.test(location.pathname)) {
      var term = new URLSearchParams(location.search).get("q");
      if (term && q("[data-ezplp]")) remember(term); /* only searches that found something */
    }
    window.addEventListener("pageshow", function (e) { if (e.persisted) closeDialog(); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

/* Ban-159 (anh 24/10 23:16) — computers: the header search box shows "Search gifts for <b>Mom</b>" with the last word
   taking turns (Mom, Dad, Couples…), the same as the phone homepage search bar (ez-home.js words(): 2.6 s, 0.18 s
   fade). Before, the box showed Dawn's floating label "Search" 3px below the middle. The text is a span over the input
   (sections/header.liquid, [data-ezs-ph]; lead + words in Customize › Header); CSS hides it once something is typed
   (input:not(:placeholder-shown) ~ span). Paused while the box has focus or text, while the tab is hidden, and with
   reduced motion. One text node change every 2.6 s, no layout read. */
(function () {
  "use strict";
  function start() {
    var ph = document.querySelector("[data-ezs-ph]");
    var kw = ph && ph.querySelector(".ezs-ph__kw");
    if (!kw || !kw.firstChild || ph.__ezsPh) return;
    ph.__ezsPh = true;
    if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var list = (ph.getAttribute("data-words") || "").split(",").map(function (w) { return w.trim(); }).filter(Boolean);
    if (list.length < 2) return;
    var input = ph.parentNode && ph.parentNode.querySelector("input[type=search]"), i = 0;
    setInterval(function () {
      if (document.hidden || (input && (input.value || document.activeElement === input))) return;
      i = (i + 1) % list.length;
      kw.classList.add("is-out");
      setTimeout(function () { kw.firstChild.nodeValue = list[i]; kw.classList.remove("is-out"); }, 180);
    }, 2600);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
